module.exports = __webpack_public_path__ + "img/sh-img4.cab6700f.png";